<wbo-report-page #reportPage [formGroup]="reportPage.formGroup">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row [label]="'wbo.report.edit.options'">
                <wbo-entity-group-by-report-criteria [showMembershipTypeOption]="true"></wbo-entity-group-by-report-criteria>
            </fui-row>
            <fui-row>
                <wbo-member-report-selection></wbo-member-report-selection>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-report-page>
